/**
 * @file index.tsx
 *
 * @fileoverview Renders a custom landing page icon.
 */
import React from 'react';
import { Image } from '~/jobiqo/types/types';

interface ProductCustomIconProps {
  iconCustom: Image;
  width?: number;
  height?: number;
}

export const ProductCustomIcon: React.FC<ProductCustomIconProps> = ({
  iconCustom,
  ...props
}) => {
  let width;
  const { title, url, alt } = iconCustom;

  // Get with from the custom image first, if not check if its passed in props.
  width = iconCustom?.width;
  if (!width) {
    width = (props as any)?.width;
  }

  return (
    <div style={{ width: `${width}px` }}>
      <img src={url} alt={alt ?? ''} title={title ?? ''} />
    </div>
  );
};

export default ProductCustomIcon;
